import React, { useEffect, useRef, useState } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";
import Button from "../atoms/buttons/Button";
import FooterEmpty from "../modules/layout/FooterEmpty";
import Header from "../modules/layout/Header";
import { applyStepState } from "../../recoil/pageStep";
import { isPracticeState, trialState } from "../../recoil/record";
import useExamActions from "../../api/hooks/exam";
import { logoURL } from "./ApplyRouter";
import { useSearchParams } from "react-router-dom";

const ModeSelect = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const [applyStep, setApplyStep] = useRecoilState(applyStepState);
	const setIsPractice = useSetRecoilState(isPracticeState);
	const examActions = useExamActions();
	const [trial, setTrial] = useRecoilState(trialState);

	const [isLogo, setLogo] = useState();

	// const getGroupLogo = async () => {
	//   const url = new URL(window.location.href);

	//   const urlParams = url.searchParams;

	//   console.log(urlParams.get("groupId"));

	//   const res = await examActions.getGroupLogo({
	//     groupId: urlParams.get("groupId"),
	//   });

	//   console.log("res :", res);
	//   logoURL.uuid = urlParams.get("groupId");

	//   if (res.status === 200) {
	//     let hostURL = "https://" + window.location.host;

	//     if (hostURL.includes("localhost")) {
	//       hostURL = "https://opic.airsoundtest.com";
	//     }

	//     logoURL.logo = hostURL + res.data.url;
	//     logoURL.title = res.data.title + " ";

	//     console.log("logoURL.logo :", logoURL.logo);

	//     setLogo(true);
	//   } else {
	//     setApplyStep(9);
	//   }
	// };

	useEffect(() => {}, [isLogo]);

	useEffect(() => {
		async function fetchHandler() {
			const uid = searchParams.get('uid')
			const res = await examActions.isPracticeDone(uid);
			if (res.status === 200) {
				const data = res.data.is_test;
				if (!data) {
					setTrial(false)
				} else {
					setTrial(true)
				}
			}
		}
		fetchHandler();
	}, [])

	return (
		<div>
			<Header />
			<div className="base-sec mode-select">
				<div className="background-color-w">
					<div className="base-sec-top flex">
						<div>
							<p className="title">영어 말하기 평가</p>
						</div>
					</div>
					<div className="base-sec-sec mode-select-sec text-align-center">
						{/* <div>
							<img
								className="main_logo_img"
								src="../../../../img/khcp/khcp_logo.png"
								alt="khcp_logo"
								style={{ width: "250px", height: "auto" }}
							/>
						</div> */}
						<p className="mode-title">
							{/* {logoURL.title} 주제 적응형 영어말하기
              <br />
              모의 평가 */}
							KHNP 영어 말하기 모의평가
						</p>
						<p className="mode-en">Evaluation of English Speaking for KHNP</p>
						<Button
							size="xl"
							color="secondaryGray"
							onClick={() => {
								// alert("준비 중입니다.");
								setIsPractice(true);
								setApplyStep((old) => old + 1);
							}}
						>
							체험하기
						</Button>
						<Button
							size="xl"
							color="primary"
							onClick={() => {
								if (!trial) {
									alert("응시에 앞서 체험하기를 진행해주세요.")
								} else {
									setApplyStep((old) => old + 1);
								}
							}}
						>
							응시하기
						</Button>
					</div>
					<FooterEmpty />
				</div>
			</div>
		</div>
	);
};

export default ModeSelect;
